module.exports = __webpack_public_path__ + "img/1580084571.4c94223e.jpg";